import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GroupService } from '../../../../../common/services/Group.service';
import { UserService } from '../../../../../common/services/User.service';
import { Observable } from 'rxjs';
import {
  displayPhoneTypeColumn,
  displayStatusColumn,
  getArray,
  getDisplayGroupColumn,
  getDisplayNameColumn,
  getDisplayRoleColumn,
  getDisplaySystemStatusColumn,
  getDisplayUserNameColumn,
  getName,
} from './agents.const';
import { Role } from '../../setting/expert/expert.const';
import { SocketService } from '../../../../../common/services/Socket.service';
import { Router } from '@angular/router';
import { BaseListComponent } from '../../../../../components/base-list.component';
import { MonitorTab, MonitorTabList } from '../monitors.const';
import * as _ from 'lodash';
import { FormFieldType, ModalType } from '../../../../../components/modals/modal-form-template/modal-form.const';

declare var $: any;

@Component({
  selector: 'monitors-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.css'],
})
export class AgentsComponent extends BaseListComponent implements OnChanges, AfterViewInit {
  @ViewChild('changeStatus') changeStatus: ElementRef;
  @Input() dataAgents: any = [];
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  public filterStatus = [
    { id: '-1', text: 'Trạng thái hệ thống' },
    { id: 'AVAILABLE', text: 'Available' },
    { id: 'NOT AVAILABLE', text: 'Unavailable' },
  ];
  public filterGroup = [];
  public groups = [];
  public allAgentStatus = [];
  public allStatus = [];
  public allPhoneType = [
    { id: 0, text: 'Gọi dùng trình duyệt' },
    { id: 1, text: 'Gọi dùng Sip Phone' },
    { id: 2, text: 'Gọi dùng Sip Phone (No Login)' },
    { id: 3, text: 'Gọi dùng số điện thoại' },
  ];
  public allChannelStatus = [];
  public sortBy = 'username';
  public sortAsc = true;
  public sortArray = [
    { id: 'username', text: 'Username' },
    { id: 'name', text: 'Tên' },
    { id: 'display_role', text: 'Vai trò' },
    { id: 'display_group', text: 'Bộ phận' },
    { id: 'status', text: 'Trạng thái trả lời web' },
  ];

  public modelFilter: any = {};
  public targetAgent: any = {};
  public allGroups = [];
  public allAgents = [];
  public readonly Role = Role;
  public readonly tabList = MonitorTabList;
  public readonly MonitorTab = MonitorTab;
  public monitorConnection: any;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    protected groupService: GroupService,
    protected userService: UserService,
    protected socketService: SocketService,
    protected router: Router
  ) {
    super(changeDetector, toastr, modalService);
    this.allStatus = getArray(2);
    this.allAgentStatus = getArray(1);
    this.allChannelStatus = getArray(0);
  }

  async ngOnInit() {
    this.modelFilter = {};
    Observable.forkJoin([this.userService.all({}), this.groupService.allGroup({ target: 'user' })]).subscribe(res => {
      if (res[0].status == 200 && !res[0].error) {
        this.allAgents = res[0].data.list;
      }
      if (res[1].status == 200 && !res[1].error) {
        let groups = [{ id: '-1', text: 'Bộ phận' }];
        this.allGroups = res[1].data.filter(r => r.target === 'user');
        for (let group of this.allGroups) {
          groups.push({ id: group.id, text: group.name });
        }
        this.filterGroup = groups;
      }
      this.loadData();
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    await this.loadData();
  }

  ngAfterViewInit(): void {}

  buildDisplay(r) {
    r.name = getName(r, this.allAgents);
    r.display_name = getDisplayNameColumn(r, this.allAgents);
    r.display_username = getDisplayUserNameColumn(r, this.allAgents);
    r.display_role = getDisplayRoleColumn(r, this.user, this.allAgents);
    r.display_group = getDisplayGroupColumn(r, this.allGroups);
    r.display_availabel = getDisplaySystemStatusColumn(r);
    r.display_status = displayStatusColumn(r.status, this.allStatus);
    r.display_phone_type = displayPhoneTypeColumn(r.phoneType, this.allPhoneType);
    return r;
  }

  async loadData() {
    this.data = this.dataAgents.map(data => data);
    if (this.modelFilter.keyword) {
      this.data = this.data.filter(r => {
        const name = getName(r, this.allAgents) || '';
        const checkName = name.toLowerCase().includes(this.modelFilter.keyword.toLowerCase());
        const checkUsername = r.username.toLowerCase().includes(this.modelFilter.keyword.toLowerCase());
        return checkName || checkUsername;
      });
    }
    if (this.modelFilter.systemStatus) {
      this.data = this.data.filter(r => r.systemStatus === this.modelFilter.systemStatus);
    }
    if (this.modelFilter.group_id) {
      this.data = this.data.filter(r => r.groupId === this.modelFilter.group_id);
    }
    this.initPage(this.data.length);
    this.data = this.data
      .map(r => {
        return this.buildDisplay(r);
      })
      .sort((a, b) => this.sortData(a, b, this.sortBy, this.sortAsc));
  }

  changeAgentStatus(value) {
    this.is_loading = true;
    const agent = this.targetAgent;
    if (agent.role == Role.Agent && value == 'NOACD') {
      this.throwError('Agent không được phép đổi sang trạng thái này!');
      return;
    }
    this.data = this.data
      .map(g => {
        if (g.agentId === agent.agentId) {
          g.status = value;
          g.display_status = displayStatusColumn(g.status, this.allStatus);
        }
        return g;
      })
      .filter(g => g.status !== 'LOGOUT');
    if (value === 'LOGOUT') {
      if (this.user.agent_id == agent.agentId) {
        this.socketService.logout();
        (window as any).unregister();
        console.log('Logged out!!!');
        localStorage.clear();
        this.router.navigate(['/login']);
      } else {
        this.socketService.logoutUser(agent.agentId, agent.username);
      }
    } else {
      let data = {
        status: value,
        agentId: agent.agentId,
        superAgentId: this.user.agent_id,
      };
      this.socketService.changeAgentStatusSupervisor(data);
    }
    setTimeout(() => {
      this.is_loading = false;
    }, 2000);
  }

  changeChannelStatus($event, agent, channel) {
    this.is_loading = true;
    let data = {
      agentId: agent.agentId,
      superAgentId: this.user.agent_id,
    };
    data[channel] = $event;
    this.data = this.data.map(data => {
      if (data.agentId === agent.agentId) {
        data[channel] = $event.value;
      }
      return data;
    });
    this.socketService.changeAgentStatusSupervisor(data);
    setTimeout(() => {
      this.is_loading = false;
    }, 2000);
  }
  changePhoneType(user) {
    this.is_loading = true;
    this.socketService.voiceOtherSetting({
      username: user.username,
      agentId: user.agentId,
      phoneType: user.phoneType,
    });
    setTimeout(() => {
      this.dataAgents = this.dataAgents.map(data => {
        if (data.agentId === user.agentId) {
          data.phoneType = user.phoneType;
        }
        return data;
      });
      this.loadData();
      this.is_loading = false;
    }, 2000);
  }

  changeFilter($event, key) {
    let value = $event.value;
    if (value === '-1') {
      value = '';
    }
    if (key === 'sortBy') {
      this.sortBy = value;
    } else {
      this.modelFilter[key] = value;
    }
    this.loadData().then();
  }

  async setUpModal() {
    this.modelContent = {
      type: ModalType.Primary,
      submit_title: 'Chuyển',
    };
    switch (this.typeModal) {
      case 'status':
        this.modelContent.title = 'Chuyển trạng thái';
        this.modelDisplay = [
          {
            key: 'status',
            label: 'Trạng thái',
            type: FormFieldType.Select,
            value: this.model.status,
            required: true,
            disabled: false,
            width: 'full',
            order: 0,
            options: {
              data: this.allStatus,
            },
          },
        ];
        break;
      case 'phoneType':
        this.modelContent.title = 'Chuyển chế độ nghe gọi';
        this.modelDisplay = [
          {
            key: 'phoneType',
            label: 'Chế độ nghe gọi',
            type: FormFieldType.Select,
            value: this.model.phoneType,
            required: true,
            disabled: false,
            width: 'full',
            order: 0,
            options: {
              data: this.allPhoneType,
            },
          },
        ];
        break;
    }
  }

  async openModalChangeStatus(item, channel) {
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-sm',
      keyboard: false,
    };
    this.targetAgent = item;
    switch (channel) {
      case 'status':
        this.typeModal = 'status';
        this.model.status = item.status;
        await this.setUpModal();
        this.openModal(this.changeStatus, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case 'phoneType':
        this.typeModal = 'phoneType';
        this.model.phoneType = item.phoneType;
        await this.setUpModal();
        this.openModal(this.changeStatus, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
    }
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    switch (this.typeModal) {
      case 'status':
        if (_.isEmpty(this.model.status)) {
          this.message = { class: 'alert dark alert-danger', content: 'Lỗi' };
          return;
        }
        this.changeAgentStatus(this.model.status);
        break;
      case 'phoneType':
        if (_.isEmpty(this.model.phoneType)) {
          this.message = { class: 'alert dark alert-danger', content: 'Lỗi' };
          return;
        }
        const user = this.targetAgent;
        this.changePhoneType({
          username: user.username,
          agentId: user.agentId,
          phoneType: this.model.phoneType,
        });
        break;
    }
    this.closeModal();
  }

  private sortData(a: any, b: any, sortBy: string, sortAsc: boolean): number {
    const compare = (val1: string, val2: string) => {
      return sortAsc ? val1.localeCompare(val2) : val2.localeCompare(val1);
    };

    switch (sortBy) {
      case 'username':
        return compare(a.username, b.username);
      case 'name':
        return compare(a.name, b.name);
      case 'display_role':
        return compare(a.display_role, b.display_role);
      case 'display_group':
        return compare(a.display_group, b.display_group);
      case 'status':
        return compare(a.status, b.status);
      default:
        return 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/monitors/agents/agents.component.ts